"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _link = _interopRequireDefault(require("@clayui/link"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireWildcard(require("react"));

var _DropDownContext = require("./DropDownContext");

var _excluded = ["active", "children", "className", "data-index", "disabled", "href", "innerRef", "onClick", "role", "roleItem", "spritemap", "style", "symbolLeft", "symbolRight", "tabIndex"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ClayDropDownItem = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      dataIndex = _ref['data-index'],
      disabled = _ref.disabled,
      href = _ref.href,
      innerRef = _ref.innerRef,
      _onClick = _ref.onClick,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'presentation' : _ref$role,
      _ref$roleItem = _ref.roleItem,
      roleItem = _ref$roleItem === void 0 ? 'menuitem' : _ref$roleItem,
      spritemap = _ref.spritemap,
      style = _ref.style,
      symbolLeft = _ref.symbolLeft,
      symbolRight = _ref.symbolRight,
      tabIndex = _ref.tabIndex,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var clickableElement = _onClick ? 'button' : 'span';
  var ItemElement = href ? _link.default : clickableElement;

  var _useContext = (0, _react.useContext)(_DropDownContext.DropDownContext),
      close = _useContext.close,
      closeOnClick = _useContext.closeOnClick,
      tabFocus = _useContext.tabFocus;

  return /*#__PURE__*/_react.default.createElement("li", {
    "aria-selected": active,
    "data-index": dataIndex,
    ref: ref,
    role: role,
    style: style
  }, /*#__PURE__*/_react.default.createElement(ItemElement, _extends({}, otherProps, {
    className: (0, _classnames.default)('dropdown-item', className, {
      active: active,
      disabled: disabled
    }),
    disabled: disabled,
    href: href,
    onClick: function onClick(event) {
      if (_onClick) {
        _onClick(event);
      }

      if (event.defaultPrevented) {
        return;
      }

      if (closeOnClick) {
        close();
      }
    },
    ref: innerRef,
    role: roleItem,
    tabIndex: disabled || !tabFocus ? -1 : tabIndex
  }), symbolLeft && /*#__PURE__*/_react.default.createElement("span", {
    className: "dropdown-item-indicator-start"
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: symbolLeft
  })), children, symbolRight && /*#__PURE__*/_react.default.createElement("span", {
    className: "dropdown-item-indicator-end"
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: symbolRight
  }))));
});

ClayDropDownItem.displayName = 'ClayDropDownItem';
var _default = ClayDropDownItem;
exports.default = _default;